"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemediationAction = void 0;
var RemediationAction;
(function (RemediationAction) {
    RemediationAction[RemediationAction["Other"] = 1] = "Other";
    RemediationAction[RemediationAction["Take Fixture Offline"] = 2] = "Take Fixture Offline";
    RemediationAction[RemediationAction["Post Signs"] = 4] = "Post Signs";
    RemediationAction[RemediationAction["Routine Flushing"] = 8] = "Routine Flushing";
    RemediationAction[RemediationAction["Replace Fixture"] = 16] = "Replace Fixture";
    RemediationAction[RemediationAction["Partially Replace Fixture"] = 32] = "Partially Replace Fixture";
})(RemediationAction = exports.RemediationAction || (exports.RemediationAction = {}));
//# sourceMappingURL=RemediationAction.js.map